type GetMapMatchIdsFilteredByTimeFilterProps = {
  filteredMatches: Set<number>;
  mapMatchIdsByTournamentIds: Map<number, Set<number>>;
};

export const getMapMatchIdsFilteredByTimeFilter = <T extends Map<number, Set<number>>>({
  filteredMatches,
  mapMatchIdsByTournamentIds,
}: GetMapMatchIdsFilteredByTimeFilterProps): T => {
  const mapMatchIds = new Map() as T;

  mapMatchIdsByTournamentIds.forEach((matchIds, tournamentId) => {
    const filteredMatchIds = new Set<number>();

    matchIds.forEach((matchId) => {
      if (filteredMatches.has(matchId)) {
        filteredMatchIds.add(matchId);
      }
    });

    if (filteredMatchIds.size === 0) {
      return false;
    }

    mapMatchIds.set(tournamentId, filteredMatchIds);
  });

  return mapMatchIds;
};
